<template>
    <div class="board">
        <div class="bar">
            <b-icon icon="card-checklist" class="icon"></b-icon>
            <span>รายชื่อลูกค้าฟลีต</span>
        </div>

        <div class="content">
            <div class="filter form mb-4">
                <fleet-filter @lookup="filterFleetList($event)"></fleet-filter>
            </div>

            <div class="mb-4 text-right">
                <button class="btn btn-main" @click="openFleetForm('')">เพิ่มลูกค้าฟลีต</button>
            </div>

            <perfect-scrollbar>
                <table>
                    <thead>
                        <tr>
                            <th class="action-column"></th>
                            <th>ชื่อบริษัท</th>
                            <th>ที่อยู่</th>
                            <th>ผู้ติดต่อ</th>
                            <th>ข้อมูลวางบิล</th>
                            <th>หมายเหตุ</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in fleetList" :key="index">
                            <td class="text-center text-nowrap">
                                <button class="icon" @click="openFleetForm(item.key)"><b-icon icon="pencil"></b-icon></button>
                                <button class="icon" @click="deleteFleet(item)"><b-icon icon="trash"></b-icon></button>
                            </td>
                            <td>
                                <span class="main">{{ item.company }}</span>
                                <span class="text-nowrap"><b-icon icon="card-text" class="icon"></b-icon> {{ item.taxId }}</span>
                            </td>
                            <td>{{ item.address }}</td>
                            <td>
                                <span class="main">{{ item.contactPerson }}</span>
                                <span class="text-nowrap"><b-icon icon="telephone" class="icon"></b-icon> {{ item.contactTel }}</span>
                            </td>
                            <td>
                                <span><strong>วันที่วางบิล:</strong> {{ item.billDate }}</span>
                                <span><strong>ระยะเครดิต (วัน):</strong> {{ item.creditPeriod }}</span>
                                <span><strong>เงื่อนไขการชำระเงิน:</strong> {{ getPaymentMethodName(item.paymentMethod) }}</span>
                            </td>
                            <td>{{ item.remark }}</td>
                        </tr>
                    </tbody>
                </table>
            </perfect-scrollbar>

            <loader-spinner :isDisplay="isLoading" class="mt-4 mb-4"></loader-spinner>

            <div class="no-data" v-if="fleetList.length === 0 && !isLoading">
                <b-icon icon="exclamation-diamond"></b-icon>
                <span>ไม่พบรายการลูกค้าฟลีต</span>
            </div>
        </div>

        <fleet-modal-form :isDisplay="isShowFleetForm" :keyData="fleetKeyId" @hide="closeFleetForm($event)"></fleet-modal-form>
    </div>
</template>

<script>
import FleetFilter from '@/components/fleet/Filter';
import FleetModalForm from '@/components/fleet/ModalForm';
import DBFleet from '@/database/Fleet';
import ModelKeywordFilter from '@/resources/models/KeywordFilter';
import OptionPaymentMethod from '@/database/staticOption/PaymentMethod';

export default {
    components: {
        FleetFilter,
        FleetModalForm
    },
    data() {
        return {
            isShowFleetForm: false,
            fleetKeyId: '',
            fleetList: [],
            fleetFilter: ModelKeywordFilter.data(),
            isLoading: false
        }
    },
    mounted() {
        this.loadFleetList();
    },
    methods: {
        openFleetForm(key) {
            this.fleetKeyId = key;
            this.isShowFleetForm = true;
        },
        closeFleetForm(isReload) {
            this.isShowFleetForm = false;

            if (isReload) {
                this.loadFleetList();
            }
        },
        filterFleetList(value) {
            this.fleetFilter = value;
            this.loadFleetList();
        },
        filterResult(result) {
            if (this.fleetFilter.keyword) {
                result = result.filter(x => x.company?.toLowerCase().indexOf(this.fleetFilter.keyword.toLowerCase()) > -1 
                                            || x.taxId?.toLowerCase().indexOf(this.fleetFilter.keyword.toLowerCase()) > -1
                                            || x.contactPerson?.toLowerCase().indexOf(this.fleetFilter.keyword.toLowerCase()) > -1
                                            || x.contactTel?.toLowerCase().indexOf(this.fleetFilter.keyword.toLowerCase()) > -1
                                            || x.remark?.toLowerCase().indexOf(this.fleetFilter.keyword.toLowerCase()) > -1);
            }

            return result;
        },
        async loadFleetList() {
            this.isLoading = true;
            this.fleetList = [];
            const result = await DBFleet.get();

            if (result.content && result.content.length > 0) {
                // Filter Result
                result.content = this.filterResult(result.content);

                // Place into the Object
                this.fleetList = result.content;
            }

            this.isLoading = false;
        },
        deleteFleet(item) {
            this.$swal({
                title: 'ลบลูกค้าฟลีต?',
                text: 'โปรดยืนยันว่าต้องการลบลูกค้าฟลีต',
                icon: 'question',
                showCancelButton: true
            }).then(async (result) => {
                if (result.isConfirmed) {
                    const loader = this.$AppUtility.renderLoadBackdrop();

                    await DBFleet.delete(item);

                    this.loadFleetList();
                    loader.hide();
                }
            });
        },
        getPaymentMethodName(key) {
            return OptionPaymentMethod.service.getValueByKey(key);
        }
    }
}
</script>